import { ComponentIds, } from "@inter-ikea-core/core";
import removeUnvalidEntities from "./removeUnvalidEntities";
const validateSections = (services, _newComponent, entityTemplate) => {
    const draggedEntity = services.sceneManager.entities.find((entity) => {
        var _a, _b;
        return entity.hasComponent(ComponentIds.DRAGGABLE_COMPONENT_ID) &&
            ((_b = (_a = entity
                .getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.templateId) === null || _b === void 0 ? void 0 : _b.includes(entityTemplate));
    });
    if (draggedEntity) {
        services.sceneManager.entities.forEach((item) => {
            removeUnvalidEntities(services, item);
        });
    }
};
export default validateSections;
